import { FormikHelpers } from "formik";
import UnitForm from "./CreateUnitForm";
import { useGetUnit } from "./api/getUnit";
import { useEditUnit } from "./api/editUnit";
import EditUnitForm from "./EditUnitForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditUnit = ({handleCloseModal, unitId}: EditUnitProps)  => {
  const getUnitQuery = useGetUnit({unitId: unitId})
  const editUnitMutation = useEditUnit({data: {}, unitId});

  const initialValues: IEditUnitForm = {
    description: getUnitQuery.data?.description ? getUnitQuery.data.description : "",
    placeID: getUnitQuery.data?.placeID ? getUnitQuery.data.placeID.toString() : "",
    unID: getUnitQuery.data?.unID ? getUnitQuery.data.unID : "",
    sapCode: getUnitQuery.data?.sapCode ? getUnitQuery.data.sapCode : "",
    isEmporiki: getUnitQuery.data?.isEmporiki ? getUnitQuery.data.isEmporiki : false,
    isCiti: getUnitQuery.data?.isCiti ? getUnitQuery.data.isCiti : false,
    filepath: getUnitQuery.data?.filepath ? getUnitQuery.data.filepath : "",
    hubType: getUnitQuery.data?.hubType ? getUnitQuery.data.hubType : "",
    anetVoice: getUnitQuery.data?.anetVoice ? getUnitQuery.data.anetVoice : "",
    comments: getUnitQuery.data?.comments ? getUnitQuery.data.comments : "",
    deleted: getUnitQuery.data?.deleted ? getUnitQuery.data.deleted : false,
  };


  const handleSubmit = async (values: IEditUnitForm, { setSubmitting }: FormikHelpers<IEditUnitForm>): Promise<void> => {
    try {
      await editUnitMutation.mutateAsync({
        data: values,
        unitId: unitId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getUnitQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getUnitQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Μονάδας.</div>
    )
  }

  return (
    <>
      {!getUnitQuery.isLoading && getUnitQuery.data &&
        <EditUnitForm initialValues={initialValues}  onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditUnitProps {
  unitId: number;
  handleCloseModal: () => void;
}

export default EditUnit;